var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("车辆轨迹实时监控")])}
var staticRenderFns = []

export { render, staticRenderFns }